import { ObterDetalhesSolicitacaoBonificacao } from "./metodos/ObterDetalhesSolicitacaoBonificacao";

export const BonificacaoService = { 
    ObterDetalhesSolicitacaoBonificacao
};